import { render, staticRenderFns } from "./InserirSorteio.vue?vue&type=template&id=675b6d38&"
import script from "./InserirSorteio.vue?vue&type=script&lang=js&"
export * from "./InserirSorteio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports